import createWorkerFunction from "../../createWorkerFunction.js";
import createWorkerInNode from "../../environment/createWorkerInNode.js";
export default function createWorkerFunctionInNode(fnOrAlias) {
    return createWorkerFunction(createWorkerInNode, fnOrAlias);
}
